import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class LicenseClassTypeService extends BaseApiService {
    public getCustomerCredentialTypesForBusinessTransaction(businessTransactionId: number) {
        return this.get('Driver/LicenseClass/Available/' + businessTransactionId);
    }

    public getLicenseClasses() {
        return this.get('Driver/LicenseClass/LicenseClasses');
    }
}
